import { render } from "./StatusDashboard.vue?vue&type=template&id=87d33f20"
import script from "./StatusDashboard.vue?vue&type=script&lang=js"
export * from "./StatusDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__